import React from 'react'
import StudentDashboard from './StudentDashboard';
import Dashboard from './Dashboard/Dashboard';
import "./Dashboard/Dashboard.css"
import { SelectField } from 'react-md';
import LoadingSpinner from '../components/LoadingSpinner';


export default class ShowDashboard extends React.Component {

  constructor(props)
    {
        super(props);
        this.queryParams = new URLSearchParams(this.props.location.search);
        this.state = {
          showNewDashboard: false,
          loading: false,
          courses: [],
          studentEnrollments: [],
          selectedCourseID: this.queryParams.get('courseID') ? parseInt(this.queryParams.get('courseID')) : -1,
          quizID: this.queryParams.get('quizID') ? parseInt(this.queryParams.get('quizID')) : null,
          tab: this.queryParams.get('tab') ? parseInt(this.queryParams.get('tab')) : null,
          courseID: this.queryParams.get('courseID') ? parseInt(this.queryParams.get('courseID')) : null
        };
    }

  componentDidMount() {
    this.setState({
      loading: true,
    })
    this.getStudentCourses();
  }

  getStudentCourses() {
    const responsePromise = this.props.apiService({
      method: "POST",
      url: "/getStudentSectionEnrollment",
    });

    responsePromise.then(res => {
      if (res && res.data && res.data.data && res.data.data.enrollmentData) {
        let newCourses = [];
        const enrolledDataArr = res.data.data.enrollmentData;
        enrolledDataArr?.forEach((enrollData, index) => {
          newCourses.push({
            key: 'KEY_' + index,
            title: enrollData.course_name,
            value: enrollData.course_id,
          })
        });

        if (this.state.selectedCourseID === -1) {
          let firstCourseIndex = enrolledDataArr.findIndex(data => data?.enable_practice_and_performance);
          if (firstCourseIndex < 0) {
            firstCourseIndex = 0
          }
          let firstCourse = enrolledDataArr[firstCourseIndex]
          console.debug("firstCourse", firstCourse)
          this.setState({
            selectedCourseID: this.state.selectedCourseID === -1 ? (firstCourse ? firstCourse.course_id : -1) : this.state.selectedCourseID,
            showNewDashboard: firstCourse ? firstCourse?.enable_practice_and_performance : false,
          })
        } else {
          let index = enrolledDataArr.findIndex(ele => ele.course_id === this.state.selectedCourseID)
          
          if (index > -1) {
            let course = enrolledDataArr[index];
            console.debug("course------", course)
            this.setState({
              selectedCourseID: this.state.selectedCourseID,
              showNewDashboard: course ? course?.enable_practice_and_performance : false,
            })
          }
        }

        this.setState({
          studentEnrollments: enrolledDataArr,
          courses: newCourses
        });
      }
    }).finally(() =>{
      this.setState({
        loading: false,
      })
    })

  }

  render() {
    
    if(this.state.loading)
        return <LoadingSpinner></LoadingSpinner>;

    return <div>
      <div className="flex-wrap justify-content-start align-items-center mb-4"
      style={{
        display: this.state.courses.length ? 'flex' :'none'
      }}>
        <div className="fontClass-18" style={{ color: "#bb0000" }}>
          <b>Pick your course:</b>
        </div>
        <SelectField
          id="selectCourses"
          className="md-cell md-cell--4  md-cell--6-phone DashBoardSelectFieldBigClass"
          placeholder="Select Course"
          itemLabel="title"
          menuItems={this.state.courses}
          value={this.state.selectedCourseID}
          onChange={(courseID) => {
              let index = this.state.studentEnrollments.findIndex(c => c.course_id === courseID);
              if (index < 0) {
                return
              }
              let enrollData = this.state.studentEnrollments[index]
              this.setState({
                selectedCourseID: courseID,
                showNewDashboard: enrollData ? enrollData.enable_practice_and_performance : false,
              })
          }}
        />
      </div>
      {
        this.state.showNewDashboard ? (
          <Dashboard {...this.props} selectedCourseID={this.state.selectedCourseID} />
        ) : (
          <StudentDashboard selectedCourseID={this.state.selectedCourseID} {...this.props} />
        )
      }
    </div>
  }

}